import { useQuery } from "react-query";
import axios from "axios";
const doAction = async (path) => {
  try {
    const res = await axios.get(path);
    return res.data;
  } catch (error) {
    throw error.response.data;
  }
};

const useOpenRequest = (path, staleTime = 1) => {
  return useQuery(["com-init-get", path], () => doAction(path), {
    staleTime: staleTime * 60 * 1000,
    retry: 0,
  });
};

export default useOpenRequest;
